var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"header"}},[_c('div',{staticClass:"button",on:{"click":function($event){return _vm.Open($event)}}},[_vm._v("抢占5大福利")])])}
var staticRenderFns = []

export { render, staticRenderFns }